import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=0b5c2872&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"
import style0 from "./NavigationComponent.vue?vue&type=style&index=0&id=0b5c2872&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c2872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5c2872')) {
      api.createRecord('0b5c2872', component.options)
    } else {
      api.reload('0b5c2872', component.options)
    }
    module.hot.accept("./NavigationComponent.vue?vue&type=template&id=0b5c2872&scoped=true", function () {
      api.rerender('0b5c2872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/NavigationComponent.vue"
export default component.exports